"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxUpdateAccountArgs = void 0;
function serializeHxUpdateAccountArgs(_arg) {
    var output = [];
    output.push(_arg.accountDeviceId);
    output.push(_arg.accountType);
    output.push(_arg.syncFrequencyType);
    output.push(_arg.syncFrequencyPollMinutes);
    output.push(_arg.emailWindow);
    output.push(_arg.accountName);
    output.push(_arg.userDisplayName !== undefined);
    if (_arg.userDisplayName !== undefined) {
        output.push(_arg.userDisplayName);
    }
    output.push(_arg.dataType);
    output.push(_arg.setIncomingServerProperties);
    output.push(_arg.incomingServerAddress);
    output.push(_arg.incomingServerPort !== undefined);
    if (_arg.incomingServerPort !== undefined) {
        output.push(_arg.incomingServerPort);
    }
    output.push(_arg.incomingServerSslScheme);
    output.push(_arg.setOutgoingServerProperties);
    output.push(_arg.outgoingServerAuthenticationRequired !== undefined);
    if (_arg.outgoingServerAuthenticationRequired !== undefined) {
        output.push(_arg.outgoingServerAuthenticationRequired);
    }
    output.push(_arg.outgoingServerAddress !== undefined);
    if (_arg.outgoingServerAddress !== undefined) {
        output.push(_arg.outgoingServerAddress);
    }
    output.push(_arg.outgoingServerPort !== undefined);
    if (_arg.outgoingServerPort !== undefined) {
        output.push(_arg.outgoingServerPort);
    }
    output.push(_arg.outgoingServerSslScheme !== undefined);
    if (_arg.outgoingServerSslScheme !== undefined) {
        output.push(_arg.outgoingServerSslScheme);
    }
    output.push(_arg.truncateMessages);
    output.push(_arg.webAccountId);
    output.push(_arg.popLeaveOnServer !== undefined);
    if (_arg.popLeaveOnServer !== undefined) {
        output.push(_arg.popLeaveOnServer);
    }
    output.push(_arg.sslCertificateValidation !== undefined);
    if (_arg.sslCertificateValidation !== undefined) {
        output.push(_arg.sslCertificateValidation);
    }
    return output;
}
exports.serializeHxUpdateAccountArgs = serializeHxUpdateAccountArgs;
